import {UploadBackfaceResponse, UploadCardsResponse, UploadFieldBackgroundResponse} from "../../types";
import axiosInstance from "../axios";

/**
 * Хелпер для загрузок файлов
 */
export default class UploadHelper {

    /**
     * Запрос на загрузку карт
     * @param formData
     * @param url
     * @private
     */
    public static uploadCardRequest(formData: FormData, url: string): Promise<UploadCardsResponse>
    {
        return this.uploadFiles(formData, url);
    }

    /**
     * Запрос на загрузку сукна игрового поля
     * @param formData
     * @param url
     */
    public static uploadFieldBackgroundRequest(formData: FormData, url: string): Promise<UploadFieldBackgroundResponse>
    {
        return this.uploadFiles(formData, url);
    }

    /**
     * Запрос на загрузку рубашки
     * @param formData
     * @param url
     */
    public static uploadBackfaceRequest(formData: FormData, url: string): Promise<UploadBackfaceResponse>
    {
        return this.uploadFiles(formData, url);
    }

    /**
     * Загрузить файлы
     * @param formData
     * @param url
     * @private
     */
    private static uploadFiles(formData: FormData, url: string): any
    {
        return new Promise((resolve, reject) => {
            axiosInstance.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then( response => {
                if (typeof response.data.error === 'undefined') {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
}
